package dev.wyns.ventrova.data

import dev.wyns.ventrova.data.model.BoundingBox
import dev.wyns.ventrova.data.model.MenuItem
import dev.wyns.ventrova.data.model.Place

/** Source of venues with vegan options. */
interface PlaceRepository {
    suspend fun placesIn(bounds: BoundingBox): List<Place>

    /** Matches name, cuisine and city, ignoring case and diacritics. */
    suspend fun search(query: String, limit: Int = 50): List<Place>

    suspend fun placesById(ids: Collection<String>): List<Place>

    /** The analysed dishes of a place (no drinks); empty when there is no menu. */
    suspend fun menuFor(placeId: String): List<MenuItem>
}
